export default __webpack_public_path__ + "static/media/carousel1.d485c7f4.jpeg";